import React from "react";
import ReactDOM from "react-dom";
import { ColumnFilter } from "./ColumnFilter";
import { formatMiles } from "../../utils/miles";

// Lightbox: se monta sobre todo el contenido via portal
const ImageLightbox = ({ src, onClose }) => {
  React.useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "rgba(0,0,0,0.78)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "zoom-out",
        animation: "lbFadeIn 0.18s ease",
      }}
    >
      <style>{`
        @keyframes lbFadeIn {
          from { opacity: 0; transform: scale(0.93); }
          to   { opacity: 1; transform: scale(1); }
        }
        @keyframes imgSpin {
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        style={{ position: "relative", display: "inline-block" }}
      >
        <img
          src={src}
          alt="Vista ampliada"
          style={{
            maxWidth: "88vw",
            maxHeight: "88vh",
            borderRadius: 12,
            boxShadow: "0 8px 48px rgba(0,0,0,0.55)",
            display: "block",
            objectFit: "contain",
          }}
        />
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          style={{
            position: "absolute",
            top: -14,
            right: -14,
            width: 32,
            height: 32,
            borderRadius: "50%",
            border: "none",
            background: "#fff",
            color: "#333",
            fontSize: 18,
            lineHeight: "32px",
            textAlign: "center",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
            padding: 0,
          }}
          title="Cerrar"
        >
          ×
        </button>
      </div>
    </div>,
    document.body
  );
};

// Imagen en miniatura con spinner de carga y lightbox al hacer click
const UserImage = ({ imagePath }) => {
  const [src, setSrc] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!imagePath) return;
    let objectUrl;
    setLoading(true);
    fetch(`https://eethsa.xyz/eethsa1/${imagePath}`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.blob();
      })
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => setSrc(null))
      .finally(() => setLoading(false));

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [imagePath]);

  // Spinner mientras carga
  if (loading) {
    return (
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          background: "#f0f4ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
        }}
      >
        <style>{`
          @keyframes imgSpin {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        <div
          style={{
            width: 20,
            height: 20,
            border: "2.5px solid #dee2e6",
            borderTop: "2.5px solid #1569c9",
            borderRadius: "50%",
            animation: "imgSpin 0.75s linear infinite",
          }}
        />
      </div>
    );
  }

  // Sin imagen
  if (!src) {
    return (
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          background: "#e9ecef",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#aaa",
          fontSize: 11,
          margin: "0 auto",
        }}
      >
        S/I
      </div>
    );
  }

  return (
    <>
      <img
        src={src}
        alt="Foto"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          objectFit: "cover",
          display: "block",
          margin: "0 auto",
          border: "2px solid #dee2e6",
          cursor: "zoom-in",
          transition: "transform 0.15s, box-shadow 0.15s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.12)";
          e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.22)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
        }}
      />
      {open && <ImageLightbox src={src} onClose={() => setOpen(false)} />}
    </>
  );
};

export const CLIENTE_COLUMNS = [
  {
    Header: "ID",
    Footer: "ID",
    accessor: "IdPacientes",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Nombre",
    Footer: "Nombre",
    accessor: "NombrePaciente",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Cedula",
    Footer: "Cedula",
    accessor: "Cedula",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Ciudad",
    Footer: "Ciudad",
    accessor: "Ciudad",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Celular",
    Footer: "Celular",
    accessor: "Celular",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Nivel",
    accessor: "nivel",
    Filter: ColumnFilter,
    Cell: (props) => {
      let color;
      if (props.value === "Nivel 1") {
        color = "green";
      } else if (props.value === "Nivel 2") {
        color = "orange";
      } else {
        color = "red";
      }
      return (
        <p style={{ textAlign: "Center", color: `${color}` }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Acceso",
    accessor: (row) => String(row.estadousuarioapp || "").toUpperCase() === "ACTIVO"
      ? "Con acceso"
      : "Sin acceso",
    id: "accesoApp",
    Filter: ColumnFilter,
    Cell: (props) => (
      <p style={{ textAlign: "Center", color: props.value === "Con acceso" ? "green" : "red" }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: "Estado",
    accessor: "estaActivo",
    Filter: ColumnFilter,
    Cell: (props) => {
      let colores = "black";
      if (props.value == "Activo") colores = "green";
      if (props.value == "Inactivo") colores = "red";
      return (
        <p style={{ color: `${colores}`, textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
];

export const COLUMNS = [
  {
    Header: "Imagen",
    accessor: "imagen",
    Filter: ColumnFilter,
    Cell: (props) => <UserImage imagePath={props.value} />,
  },
  {
    Header: "ID",
    accessor: "IdUsuario",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "nombre",
    accessor: "Nombre",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "CI",
    Footer: "CI",
    accessor: "Cedula",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Cargo",
    accessor: "IdTipoUsuario",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Ciudad",
    Footer: "Ciudad",
    accessor: "Ciudad",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Telefono",
    Footer: "Telefono",
    accessor: "Telefono",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Estado",
    accessor: "estaActivo",
    Filter: ColumnFilter,
    Cell: (props) => {
      let colores = "black";
      if (props.value == "Activo") colores = "green";
      if (props.value == "Inactivo") colores = "red";
      return (
        <p style={{ color: `${colores}`, textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
];

export const COLUMNS_LIQ = [
  {
    Header: "ID",
    accessor: "id",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Usuario",
    Footer: "CI",
    accessor: "Nombre",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Fecha de Inicio",
    accessor: "FechaInicio",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Fecha de Cierre",
    accessor: "FechaFin",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Estado",
    accessor: "estado",
    Filter: ColumnFilter,
    Cell: (props) => {
      let colores = "black";
      if (props.value == "CIERRE") colores = "RED";
      if (props.value == "LIQUIDADO") colores = "GREEN";
      if (props.value == "Liquidado") colores = "GREEN";
      if (props.value == "ENVIADOUSUARIO") colores = "ORANGE";
      if (props.value == "ENVIADOPRESTADOR") colores = "BLUE";
      return (
        <p style={{ color: `${colores}`, textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
];

export const GROUPED_COLUMNS = [
  {
    Header: "Id",
    Footer: "Id",
    accessor: "id",
  },
  {
    Header: "Nombre",
    Footer: "Nombre",
    columns: [
      {
        Header: "Nombre",
        Footer: "Nombre",
        accessor: "Nombre",
      },
      {
        Header: "Apellido",
        Footer: "Apellido",
        accessor: "Apellido",
      },
    ],
  },
  {
    Header: "Info",
    Footer: "Info",
    columns: [
      {
        Header: "CI",
        Footer: "CI",
        accessor: "CI",
      },
      {
        Header: "Ciudad",
        Footer: "Ciudad",
        accessor: "Ciudad",
      },
      {
        Header: "Telefono",
        Footer: "Telefono",
        accessor: "Telefono",
      },
    ],
  },
];

export const GENERAR_LIQUIDACION_COLUMNS = [
  {
    Header: "Fecha Entrada",
    Footer: "Fecha Entrada",
    accessor: "Fecha",
    isEditable: true,
    meta: { type: "date" },
  },
  {
    Header: "Hora Entrada",
    Footer: "Hora Entrada",
    accessor: "HoraEntrada",
    isEditable: true,
    meta: { type: "time" },
  },
  {
    Header: "Fecha Salida",
    Footer: "Fecha Salida",
    accessor: "FechaSalida",
    isEditable: true,
    meta: { type: "date" },
  },
  {
    Header: "Hora Salida",
    Footer: "Hora Salida",
    accessor: "HoraSalida",
    isEditable: true,
    meta: { type: "time" },
  },
  {
    Header: "Horas",
    Footer: "Horas",
    accessor: "horascalculadas",
    isEditable: false,
    meta: { type: "text" },
  },
  {
    Header: "Horas Extra",
    Footer: "Horas Extra",
    accessor: "horashoraextra",
    isEditable: false,
    meta: { type: "text" },
  },
  {
    Header: "Tarifa",
    Footer: "Tarifa",
    accessor: (row) =>
      Math.round(
        (row.horascalculadas + row.horashoraextra) * row.CostoHoraEmpresa
      ),
    isEditable: false,
    meta: { type: "text" },
  },
  {
    Header: "Honorario",
    Footer: "Honorario",
    accessor: (row) =>
      Math.round(
        (row.horascalculadas + row.horashoraextra) * row.CostoHoraProfesional
      ),
    isEditable: false,
    meta: { type: "text" },
  },
  {
    Header: "Enfermero",
    Footer: "Enfermero",
    accessor: "Usuario",
    isEditable: true,
    meta: { type: "selectbox" },
  },
];

export const COLUMNS_OP = [
  {
    Header: "ID",
    Footer: "ID",
    accessor: "idordendepago",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Fecha Inicio",
    accessor: "fechainicio",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Fecha Fin",
    accessor: "fechafin",
    Filter: ColumnFilter,
    Cell: (props) => {
      return (
        <p style={{ textAlign: "Center" }}>{props.value}</p>
      );
    },
  },
  {
    Header: "Estado",
    accessor: "estado",
    Filter: ColumnFilter,
    Cell: (props) => {
      let color = "";
      switch (props.value) {
        case "FINALIZADO":
          color = "green";
          break;
        case "CREADO":
          color = "orange";
          break;
        default:
          color = "black";
      }
      return (
        <p style={{ textAlign: "center", color: color }}>{props.value}</p>
      );
    },
  },
];
